export default __webpack_public_path__ + "static/media/report.c8b25568.svg";